<script>
    import { mapActions } from "vuex";
    import { apiUrl } from "@/utils";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import BaseButton from "@main/packages/BaseButton";
    import BasePrice from "@main/packages/BasePrice";

    export default {
        name: "LiteCompareProduct",
        components: { BaseButton, BasePrice },
        props: {
            product: {
                type: Object,
                required: true,
            },
            inCartList: Array,
            imagesList: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                isLoadingBuyButton: false,
            };
        },
        computed: {
            productInCart() {
                return this.inCartList.includes(this.product.offers[0].id.toString());
            },
            productName() {
                return this.product.shortName || this.product.name;
            },
            productImage() {
                const staticImage = this.imagesList[this.product.slug];
                if (staticImage) {
                    return `/static/assets/lite-compare/${this.$_name}/products/${staticImage}?v=270522`;
                }
                return apiUrl(this.product.offers[0]?.previewImage?.medium);
            },
            buttonText() {
                return this.productInCart ? "В корзине" : "Купить";
            },
        },
        methods: {
            ...mapActions("Root", ["addProductInCart"]),
            addToCard() {
                if (this.productInCart) {
                    return this.$router.push({ name: "Order" });
                }

                this.isLoadingBuyButton = true;

                this.addProductInCart({
                    quantity: 1,
                    productId: this.product.offers[0].id,
                }).then(() => {
                    this.isLoadingBuyButton = false;

                    sendAnalytics.send(sendAnalytics.events.addToCart, {
                        name: this.product.name,
                        offerId: this.product.offers[0].id,
                        price: this.product.price,
                    });
                });
            },
        },
    };
</script>

<template>
    <div class="lite-compare-product">
        <router-link
            :to="{ name: 'Product', params: { slug: product.slug } }"
            class="lite-compare-product__link"
        >
            <div class="lite-compare-product__image">
                <img :src="productImage" alt="" />
            </div>

            <div class="lite-compare-product__name">
                {{ productName }}
            </div>

            <div class="lite-compare-product__price">
                <base-price :price="product.discountPrice"></base-price>
            </div>
        </router-link>

        <base-button
            class="lite-compare-product__button"
            variant="v1"
            size="md"
            :is-loading="isLoadingBuyButton"
            :is-selected="productInCart"
            @click="addToCard"
        >
            {{ buttonText }}
            <preloader slot="preloader" :show="isLoadingBuyButton" sm-size></preloader>
        </base-button>
    </div>
</template>

<style lang="scss">
    .lite-compare-product {
        width: 100%;
    }

    .lite-compare-product__link {
        &:hover {
            .lite-compare-product__name {
                color: var(--secondary);
            }
        }
    }

    .lite-compare-product__image {
        position: relative;
        img {
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            margin: 0 auto;
        }
        &::before {
            content: "";
            display: block;
            padding-bottom: var(--lite-compare-product-image-ratio);
        }
        @include bp($bp-desktop-sm) {
            max-width: 100%;
            width: var(--lite-compare-product-image-width);
            margin: 0 auto;
        }
    }

    .lite-compare-product__name {
        @include bp($bp-desktop-sm) {
            margin-bottom: 8px;
            color: var(--lite-compare-name-color);
            font-size: var(--lite-compare-name-size);
            font-weight: var(--lite-compare-name-weight);
            transition: color 0.2s ease;
        }
    }

    .lite-compare-product__price {
        @include bp($bp-desktop-sm) {
            margin-bottom: 16px;
            color: var(--lite-compare-price-color);
            font-size: var(--lite-compare-price-size);
            font-weight: var(--lite-compare-price-weight);
        }
    }

    .lite-compare-product__button {
        width: 100%;
        max-width: 180px;
        margin: 0 auto;
    }
</style>
